import { Controller } from "stimulus"

export default class extends Controller {
  create(event) {
    event.preventDefault()

    fetch(event.currentTarget.href, {
      method: "POST",
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": this.csrfToken()
      },
      credentials: "same-origin"
    })
      .then((response) => response.text())
      .then((html) => {
        this.element.outerHTML = html
      })
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.content
  }
}
